import React from 'react'
import PropTypes from 'prop-types'
import SwitchRaw from '~/components/common/Switch'

const Switch = ({ field, form, disabled, ...props }) => (
  <SwitchRaw
    name={field.name}
    checked={field.value}
    {...field}
    {...props}
    disabled={disabled || !!form.values.__readOnly}
  />
)

Switch.defaultProps = {
  disabled: false,
}

Switch.propTypes = {
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  disabled: PropTypes.bool,
}

export default Switch
